var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { slot: "pageContent" }, slot: "pageContent" }, [
    _c(
      "div",
      { staticClass: "listPage overflow-hidden px-3" },
      [
        _c(
          "form-accordion",
          {
            staticClass: "mt-5",
            attrs: {
              title: _vm.$t("entities_setting_tb.cit"),
              isTitleUpperCase: false,
            },
          },
          [
            _c(
              "b-row",
              { staticClass: "justify-content-start" },
              [
                _vm._l(_vm.options, function (item, index) {
                  return _c(
                    "b-col",
                    {
                      key: index,
                      staticClass: "form-group",
                      attrs: { sm: "3" },
                    },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: {
                            value: 1,
                            "unchecked-value": 0,
                            disabled: _vm.IsRVM,
                          },
                          model: {
                            value: _vm.selectedValues[item.Name],
                            callback: function ($$v) {
                              _vm.$set(_vm.selectedValues, item.Name, $$v)
                            },
                            expression: "selectedValues[item.Name]",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("rights.db_rights." + item.Name) ===
                                  "rights.db_rights." + item.Name
                                  ? item.Name
                                  : _vm.$t("rights.db_rights." + item.Name)
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "4", lg: "3", xl: "3" } },
                  [
                    !_vm.IsRVM
                      ? _c(
                          "b-button",
                          {
                            staticClass:
                              "mr-3 justify-item-end responsive-button",
                            attrs: { variant: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.updateConfigurationTB()
                              },
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))])]
                        )
                      : _c(
                          "b-button",
                          {
                            staticClass:
                              "mr-3 justify-item-end responsive-button",
                            attrs: { disabled: "", variant: "primary" },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))])]
                        ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }